import { styled } from '@mui/system';
import { Box, Typography } from '@mui/material';
import { colors, fontFamilies } from '../../../../../constants/theme';
import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined';

export const LivingTruthSectionWrapper = styled(Box)(({ theme }) => ({
  maxWidth: 1100,
  width: '100%',
  background: colors.whiteText,
  borderRadius: 40,
  boxShadow: `
  -4px -4px 17.8px 0px rgba(205, 214, 223, 0.15),
   4px  4px 15px   0px rgba(205, 214, 223, 0.25)
`,
}));

export const LivingTruthSectionTitleWrapper = styled(Box)(({ theme }) => ({
  background: 'linear-gradient(180deg, #29405A 0%, #3D5570 100%)',
  maxHeight: 170,
  height: '100%',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  borderRadius: '40px 40px 0 0',
  padding: '50px 80px',
  boxShadow: `
  -4px -4px 17.8px 0px rgba(205, 214, 223, 0.15),
   4px  4px 15px   0px rgba(205, 214, 223, 0.25)
  `,
  [theme.breakpoints.down('md')]: {
    padding: '30px 40px',
  },
  [theme.breakpoints.down('sm')]: {
    padding: '20px 30px',
  },
}));

export const LivingTruthSectionTitle = styled(Typography)(({ theme }) => ({
  color: colors.whiteText,
  fontFamily: fontFamilies.gotham,
  fontWeight: 325,
  fontSize: 42,
  lineHeight: '50px',
  letterSpacing: '-0.42px',
  [theme.breakpoints.down('md')]: {
    fontSize: 32,
    lineHeight: '40px',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: 28,
    lineHeight: '36px',
  },
}));

export const HeartContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  background: '#FFFFFF33',
  width: 70,
  height: 70,
  borderRadius: '50%',
  marginRight: 30,
  [theme.breakpoints.down('md')]: {
    width: 50,
    height: 50,
  },
  [theme.breakpoints.down('sm')]: {
    width: 40,
    height: 40,
  },
}));

export const HeartIcon = styled(FavoriteBorderOutlinedIcon)(({ theme }) => ({
  color: colors.whiteText,
  width: 30,
  height: 30,
  margin: 'auto',
  [theme.breakpoints.down('md')]: {
    width: 20,
    height: 20,
  },
  [theme.breakpoints.down('sm')]: {
    width: 15,
    height: 15,
  },
}));

export const LivingTruthSectionContent = styled(Box)(({ theme }) => ({
  padding: '60px 69px 45px',
  [theme.breakpoints.down('md')]: {
    padding: '40px 40px 30px',
  },
  [theme.breakpoints.down('sm')]: {
    padding: '30px 30px 20px',
  },
}));

export const LivingTruthDescription = styled(Typography)(({ theme }) => ({
  fontFamily: fontFamilies.quicksand,
  fontWeight: 500,
  fontSize: 24,
  lineHeight: '38px',
  letterSpacing: '0.48px',
  [theme.breakpoints.down('md')]: {
    fontSize: 20,
    lineHeight: '30px',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: 18,
    lineHeight: '28px',
  },
}));

export const LivingTruthDescriptionSubtext = styled(Typography)(({ theme }) => ({
  fontFamily: fontFamilies.quicksand,
  fontWeight: 400,
  fontSize: 20,
  lineHeight: '34px',
  letterSpacing: '0.4px',
  [theme.breakpoints.down('md')]: {
    fontSize: 18,
    lineHeight: '28px',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: 16,
    lineHeight: '24px',
  },
}));

export const LivingTruthQuote = styled(Typography)(({ theme }) => ({
  fontFamily: fontFamilies.gotham,
  fontWeight: 400,
  fontSize: 28,
  lineHeight: '42px',
  letterSpacing: '-0.28px',
  color: '#29405A',
  maxWidth: 900,
  margin: '30px auto 30px 50px',
  fontStyle: 'italic',
  [theme.breakpoints.down('md')]: {
    fontSize: 24,
    lineHeight: '36px',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: 20,
    lineHeight: '30px',
  },
  '&::before': {
    content: '""',
    display: 'flex',
    position: 'absolute',
    width: 3,
    top: 0,
    left: 0,
    bottom: 0,
    background: 'linear-gradient(180deg, #29405A 0%, rgba(41, 64, 90, 0.2) 100%)',
  },
}));

export const LivingTruthQuoteContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  position: 'relative',
}));

export const ctaButtonStyles = {
  width: 'fit-content',
  margin: '0 auto',
};
